<template>
    <a href="https://mfe.gov.ro/consultare-publica-ghidul-pentru-contractarea-granturilor-de-catre-imm-uri/" target="_blank" class="yellow-warn">
        <img src="@/assets/images/warn-sign-big.png" style="width: 50px; margin-right: 10px; height: 50px">
        <div class="text-warn">
            <h3>Apel în consultare publică (22.03.2022 - 31.03.2022)</h3>
            <p>
                Ministerul Investițiilor și Proiectelor Europene a publicat în dezbatere publică, pentru o perioadă de zece zile, noul ghid privind granturile de investiții – măsura 4.1.1, potrivit deciziilor adoptate de Guvern în urma consultării cu mediul de afaceri.
            </p>
            <p v-if="sfat">
                <strong>Sfat Smis:</strong> Criteriile de departajare și eligibilitate pot suferi modificări. <strong class="red-text">Materialul de mai jos este dezvoltat în baza Ghidului Consolidat.</strong>
                Pentru a parcurge modificările propuse prin ghidul consultativ nr. 3 vă rugăm sa faceți click pe acest mesaj.
            </p>
        </div>
        <img src="@/assets/images/M3/M3Sketch/gov-logo.png" class="">
    </a>
</template>

<script>
export default {
    props: {
        sfat: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped>
.yellow-warn{
    background: #ffdf40;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 130px;
    text-decoration: none;
}
.yellow-warn .text-warn{
    width: 100%;
    max-width: 85%;
}
.yellow-warn .text-warn p{
    font-size: 13px;
    color: #454040;
}
.yellow-warn .text-warn h3{
    font-size: 17px;
    font-weight: 700;
    color: #454040;
    margin-bottom: 0;
}
.red-text{
    color: #ff1616;
}
@media (max-width: 1200px) {
    .yellow-warn{
        flex-direction: column;
        gap: 15px;
    }
    .yellow-warn .text-warn{
        max-width: 100%;
    }
}
</style>
